<template>
  <div :class="classList">
    <label v-if="label" class="d-flex"
      >{{ label.trim().replace(/\*$/, "") }}
      <span v-if="isRequired" class="asterisk-mark">*</span>
    </label>
    <div
      v-if="adminDescription && $store.getters.isAgent"
      class="admin-description"
    >
      <div v-html="adminDescription"></div>
    </div>
    <div v-if="description" class="description">
      <div v-html="description"></div>
    </div>
    <div class="timepicker-container">
      <vue-timepicker
        class="form-control"
        :format="!is24HoursFormat ? 'hh:mm A' : ''"
        :disabled="isDisabled"
        :minute-interval="minutesInterval"
        v-model="inputVal"
      ></vue-timepicker>
    </div>
    <p
      class="required-message"
      v-if="
        (inputVal == null ||
          inputVal.hh === '' ||
          inputVal.mm === '' ||
          inputVal.A === '') &&
        submitClicked &&
        isRequired &&
        !isDisabled
      "
    >
      {{ getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED") }}
    </p>
  </div>
</template>
<script>
/* This component includes a label, and a time picker
Any error of user input for the time picker (for example: required field, invalid time ...) is showed in this component */
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  name: "TimePickerWithLabel",
  components: {
    VueTimepicker,
  },
  props: {
    /* Name of the date picker component, currently, which is unused*/
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12",
    },
    // Input value, which is used for v-model
    value: [String, Object],
    defaultValue: {
      type: Object,
      default: null,
    },
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: true,
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false,
    },
    // true if disable the timepicker
    isDisabled: {
      type: Boolean,
      default: false,
    },
    minutesInterval: {
      type: Number,
      default: 15,
    },
    is24HoursFormat: {
      type: Boolean,
      default: false,
    },
    builderField: Object,
  },
  computed: {
    inputVal: {
      get() {
        const value = this.value ? this.value : this.defaultValue;
        if (this.is24HoursFormat) {
          if (value && value.A) {
            return this.convertAMPMto24Format(value);
          }
          return;
        }
        if (typeof value === "string") {
          return this.convertTimeStringToStringAMPM(value);
        }
        return value;
      },
      set(val) {
        // Check if all elements are filled
        if (val && typeof val === "object") {
          if (
            Object.values(val).includes("") &&
            Object.values(val).some((item) => item)
          ) {
            return;
          }
        }
        if (this.is24HoursFormat && val) {
          this.$emit("input", this.convertTimeToAMPM(val));
          return;
        }
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped>
.time-label {
  display: inline-block;
  width: 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/common/form-elements/TimePickerWithLabel.vue